import React, { useEffect } from "react";
import styles from "./../../assets/styles/_maskBgAnimation.module.scss";

const MaskBgAnimation = ({ children, revert = false, SPsmall = false }) => {
  useEffect(() => {
    const handleScroll = () => {
      const elementsContainer = Array.from(
        document.getElementsByClassName(styles.container)
      );

      elementsContainer.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
        if (inViewport) {
          element.classList.add(styles.animation);
        } else {
          element.classList.remove(styles.animation);
        }
      });
    };
    // Lắng nghe sự kiện scroll
    window.addEventListener("scroll", handleScroll);

    // Gọi kiểm tra ban đầu
    handleScroll();

    // Dọn dẹp sự kiện khi component bị hủy
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  return (
    <div className={`${styles.container} ${revert ? styles.revert : ""} ${SPsmall ? styles.SPsmall : ""}`}>
      <div className={styles.mask}></div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default MaskBgAnimation;
